import React from 'react'
import { Link } from 'react-router-dom';
import './Coursebox.css'
import img1 from '../../assets/course/image-1.png'
import img2 from '../../assets/coursecard/2.jpg'
import img3 from '../../assets/course/image-3.jpg'
import img4 from '../../assets/coursecard/4.jpg'
import img5 from '../../assets/course/image-5.jpg'
import img6 from '../../assets/course/image-6.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)


const Coursebox = () => {
  return (
    <div class="coursebox-section ws-section dark-background-2 pb-5">
        <div class="container">
            <div class="row g-3">
                <div class="col-lg-8">
                    <h2 class="ws-section_heading pd-03">Customized Training Programs</h2>
                </div>
                <div class="col-lg-4 align-self-center">
                    <a href="#">
                    <button class="btn-primary btn-icon">View All Courses<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                    </a>
                </div>
            </div>

            <div class="row align-items-center gx-xl-28 mt-5">
                <div class="col-lg-6 mb-5">
                    <div class="course-box">
                        <div class="course-box-top">
                            <img src={img1} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Physical Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Physical Design Training course mainly focused on giving complete hands on experience to physical design and physical verification training flow with latest tools and full lab practice.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img4} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Analog Layout Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Analog Layout Design / Custom Layout Design / IC design training course mainly focused on giving hands-on practical exposure in doing chip layout design for a given analog & mixed signal design.</p>
                        </div>
                    </div>
                </div>
                
                
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img3} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">ASIC Verification</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Mainly focused on enhancing the Design Verification skills needed by industry. The curriculum is designed to include the latest methodologies being adopted by industry.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img2} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Design For Test (DFT)</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Design For Testability (DFT) is a specialization in the SOC design cycle, to detect the manufacturing defects in a design. With the increase in size & complexity of chips.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img6} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">Analog Circuit Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">Primarily this course is designed to cover very important basics of Analog Integrated Circuit design. This course covers all the way from MOSFET modelling to Complex Analog Block designs.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-5">
                <div class="course-box">
                        <div class="course-box-top">
                            <img src={img5} alt=''/>
                        </div>
                        <div class="course-box-btn">
                            <a href='#'>know more</a>
                        </div>
                        <div class="course-box-bottom p-4">
                        <h3  class="course-title mb-3">RTL Coding and FPGA Design</h3>
                        <ul class="course-item mb-3 pl-0">
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-clock" /> <span>Offline | Online | Weekend</span></li>
                            <li class="d-flex align-items-center mb-1"> <FontAwesomeIcon icon="fa-solid fa-award" /> <span>Certificate of completion</span></li>
                        </ul>
                        <p class="course-description">RTL Coding and FPGA Design course has been designed to help to the beginners in the area of RTL coding and FPGA design. The course gives you the foundation for FPGA design in Embedded Systems along with practical design skills.</p>
                        </div>
                    </div>
                </div>
                

                
            </div>

        </div>
    </div>
  )
}

export default Coursebox